import React from "react";

import { IconButton } from "@material-ui/core";
import ArrowUpwardRoundedIcon from "@material-ui/icons/ArrowUpwardRounded";
import { withStyles } from "@material-ui/core/styles";

import SimpleTooltip from "components/SimpleTooltip";

import { moveQuestionUp } from "modules/admin/frequentlyAskedQuestions/frequentlyAskedQuestionsSlice";
import { useAppDispatch } from "store";

const StyledIconButton = withStyles(theme => ({
    root: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1)
    }
}))(IconButton);

interface MoveQuestionUpProps {
    categoryId: string,
    questionId: string
}

const MoveQuestionUp: React.FC<MoveQuestionUpProps> = (props) => {
    const { categoryId, questionId } = props;
    const dispatch = useAppDispatch();

    const handleMoveQuestionUpClick = () => {
        dispatch(moveQuestionUp(categoryId, questionId));
    };

    return (
        // @ts-ignore 
        <SimpleTooltip title="Move up">
            <StyledIconButton size="small" onClick={handleMoveQuestionUpClick}>
                <ArrowUpwardRoundedIcon />
            </StyledIconButton>
        </SimpleTooltip>
    );
};

export default MoveQuestionUp;
